// src/components/ProbrokerLoader.jsx
// Branded loader built from the PRObroker growth mark: the ring spins while
// the zigzag arrow inside draws itself over and over. Keyframes live in
// index.css under "PRObroker branded loader".
import React from "react";

const PURPLE = "#503691";

const ProbrokerLoader = ({ size = 72, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 64 64"
    fill="none"
    aria-hidden="true"
    className={className}
  >
    {/* Broken circle of the logo, doubling as the spinner ring */}
    <circle
      className="pb-loader-ring"
      cx="32"
      cy="32"
      r="26"
      stroke={PURPLE}
      strokeWidth="5"
      strokeLinecap="round"
      strokeDasharray="118 46"
    />

    {/* Growth zigzag, redrawn on a loop */}
    <path
      className="pb-loader-arrow"
      d="M15 43 L26 32 L34 38 L49 16"
      stroke={PURPLE}
      strokeWidth="5"
      strokeLinecap="round"
      strokeLinejoin="round"
      pathLength="100"
      strokeDasharray="100"
    />

    {/* Arrowhead pops in once the line reaches the top */}
    <path
      className="pb-loader-head"
      d="M39 14 H50 V25"
      stroke={PURPLE}
      strokeWidth="5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/**
 * Full-screen loading popup: frosted backdrop, white card, animated mark,
 * wordmark and a status line. Sits above modals (z-60).
 */
export const ProbrokerLoadingOverlay = ({ message = "Loading..." }) => (
  <div
    role="status"
    aria-live="polite"
    className="fixed inset-0 z-[60] flex items-center justify-center bg-black/40 p-4 backdrop-blur-sm"
  >
    <div className="flex w-full max-w-xs flex-col items-center gap-4 rounded-2xl border border-gray-100 bg-white px-8 py-8 shadow-2xl">
      <ProbrokerLoader size={76} />

      <p className="text-lg font-extrabold tracking-tight text-[#503691]">
        PRO<span className="font-semibold">broker</span>
      </p>

      <div className="flex flex-col items-center gap-2">
        <p className="text-center text-sm font-medium text-gray-600">{message}</p>
        <div className="flex items-center gap-1.5">
          <span className="pb-loader-dot h-1.5 w-1.5 rounded-full bg-[#503691]" />
          <span className="pb-loader-dot h-1.5 w-1.5 rounded-full bg-[#503691]" style={{ animationDelay: "0.15s" }} />
          <span className="pb-loader-dot h-1.5 w-1.5 rounded-full bg-[#503691]" style={{ animationDelay: "0.3s" }} />
        </div>
      </div>
    </div>
  </div>
);

export default ProbrokerLoader;
